import { render, staticRenderFns } from "./dossier-detail-component-general-tab.vue?vue&type=template&id=0e6b20b7&scoped=true"
import script from "./dossier-detail-component-general-tab.vue?vue&type=script&lang=ts"
export * from "./dossier-detail-component-general-tab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6b20b7",
  null
  
)

export default component.exports